var _title, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBurger = function SvgBurger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "ico_Burguer")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Production",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico_Burguer-Copy",
    transform: "translate(18.000000, 18.000000) scale(-1, 1) translate(-18.000000, -18.000000) ",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,17.5 C25.5522847,17.5 26,17.9477153 26,18.5 C26,19.0128358 25.6139598,19.4355072 25.1166211,19.4932723 L25,19.5 L13,19.5 C12.4477153,19.5 12,19.0522847 12,18.5 C12,17.9871642 12.3860402,17.5644928 12.8833789,17.5067277 L13,17.5 L25,17.5 Z",
    id: "line"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,23.5 C25.5522847,23.5 26,23.9477153 26,24.5 C26,25.0128358 25.6139598,25.4355072 25.1166211,25.4932723 L25,25.5 L17,25.5 C16.4477153,25.5 16,25.0522847 16,24.5 C16,23.9871642 16.3860402,23.5644928 16.8833789,23.5067277 L17,23.5 L25,23.5 Z",
    id: "line"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,11.5 C25.5522847,11.5 26,11.9477153 26,12.5 C26,13.0128358 25.6139598,13.4355072 25.1166211,13.4932723 L25,13.5 L9,13.5 C8.44771525,13.5 8,13.0522847 8,12.5 C8,11.9871642 8.38604019,11.5644928 8.88337887,11.5067277 L9,11.5 L25,11.5 Z",
    id: "line-copy"
  })))));
};
export default SvgBurger;